import { render, staticRenderFns } from "./PivotChart.vue?vue&type=template&id=a2eda882&"
import script from "./PivotChart.vue?vue&type=script&lang=js&"
export * from "./PivotChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports